import React from "react";
import Select from "antd/lib/select";
import { useTheme } from "@/components/ThemeProvider";

export default function SelectField({ form, field, ...otherProps }) {
  const { readOnly } = field;
  const { isDarkMode } = useTheme();
  return (
    <Select
      {...otherProps}
      optionFilterProp="children"
      loading={field.loading || false}
      mode={field.mode}
      getPopupContainer={trigger => trigger.parentNode}
      className={isDarkMode ? "dark-mode" : ""}>
      {field.options &&
        field.options.map(option => (
          <Select.Option key={`${option.value}`} value={option.value} disabled={readOnly}>
            {option.name || option.value}
          </Select.Option>
        ))}
    </Select>
  );
}
